"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_GROUP_COLOR_TOKENS = exports.USER_GROUPS = exports.USER_GROUP_NOT_ACTIVATED = void 0;
exports.hasCancellableWarn = hasCancellableWarn;
exports.getUserGroupName = getUserGroupName;
exports.getUserGroupColor = getUserGroupColor;
/** Есть ли в журнале запись с доступной отменой наказания. */
function hasCancellableWarn(history) {
    return (history ?? []).some((entry) => (entry.value ?? 0) > 0);
}
/** Android `UserGroupID.NotActivated` */
exports.USER_GROUP_NOT_ACTIVATED = 1;
exports.USER_GROUPS = {
    1: { name: 'Неактивированные', color: '#999999' },
    2: { name: 'Гости', color: '#999999' },
    3: { name: 'Начинающий', color: '#008000' },
    4: { name: 'Администраторы', color: '#FF0000' },
    5: { name: 'Забанен', color: '#999999' },
    6: { name: 'Пользователи', color: '#008000' },
    7: { name: 'Активные пользователи', color: '#008000' },
    8: { name: 'Друзья 4PDA', color: '#FF9900' }, // Постоянный
    9: { name: 'Модераторы', color: '#0099FF' },
    10: { name: 'Супермодераторы', color: '#0000FF' },
    11: { name: 'Помощник модератора', color: '#0099FF' },
    12: { name: 'FAQMakers', color: '#32CD32' },
    13: { name: 'Почетные форумчане', color: '#800080' },
    14: { name: 'Администрация', color: '#FF0000' },
    15: { name: 'Разработчики', color: '#BC33FF' },
    16: { name: 'Роутеры', color: '#0000CC' },
    17: { name: 'Бизнесмены', color: '#000000' },
    18: { name: 'Участник спецпроекта', color: '#9A60FF' },
    19: { name: 'Школа Модераторов', color: '#0099FF' },
    20: { name: 'Кураторы', color: '#008B8B' },
};
/**
 * Токен цвета группы по ID (`k1.a.u0`, Android 1.9.44).
 * Индексы без именованной группы → `main_text`.
 */
exports.USER_GROUP_COLOR_TOKENS = [
    'main_text', 'main_text', 'main_text', 'group_user', 'group_admin', 'group_banned',
    'main_text', 'group_active_user', 'group_friend', 'group_moderator', 'group_super_moderator',
    'group_mod_helper', 'group_faqmakers', 'group_honorable', 'main_text', 'group_developer',
    'group_router', 'group_businessman', 'group_spec_project', 'group_mod_school', 'group_curator',
    'main_text', 'main_text', 'main_text', 'main_text', 'main_text',
];
const GROUP_COLOR_LIGHT = {
    main_text: '#000000',
    group_user: '#008000',
    group_admin: '#FF0000',
    group_banned: '#A0A0A0',
    group_active_user: '#008000',
    group_friend: '#FF9900',
    group_moderator: '#0099FF',
    group_super_moderator: '#0000FF',
    group_mod_helper: '#0099FF',
    group_faqmakers: '#32CD32',
    group_honorable: '#800080',
    group_developer: '#BC33FF',
    group_router: '#000000',
    group_businessman: '#B100BF',
    group_spec_project: '#9A60FF',
    group_mod_school: '#0099FF',
    group_curator: '#008B8B',
};
const GROUP_COLOR_DARK = {
    main_text: '#B0B0B0',
    group_user: '#20A020',
    group_admin: '#FF0000',
    group_banned: '#808080',
    group_active_user: '#20A020',
    group_friend: '#FF9900',
    group_moderator: '#0099FF',
    group_super_moderator: '#0000FF',
    group_mod_helper: '#0099FF',
    group_faqmakers: '#32CD32',
    group_honorable: '#A020A0',
    group_developer: '#BC33FF',
    group_router: '#B0B0B0',
    group_businessman: '#B100BF',
    group_spec_project: '#9A60FF',
    group_mod_school: '#0099FF',
    group_curator: '#FF4500',
};
/** Название группы по ID (оф. клиент `AbstractC0112a.f1216a`, `API_Reference.md`). */
function getUserGroupName(groupId) {
    return exports.USER_GROUPS[groupId]?.name ?? 'Пользователи';
}
/** Цвет подписи группы в шапке поста (`authorGroup`, `k1.a.u0` + `colors.xml`). */
function getUserGroupColor(groupId, theme = 'light') {
    const token = exports.USER_GROUP_COLOR_TOKENS[groupId] ?? 'main_text';
    const palette = theme === 'dark' ? GROUP_COLOR_DARK : GROUP_COLOR_LIGHT;
    return palette[token] ?? palette.main_text;
}
